<template>
  <cool-select :list="counterparties"
               option-value="id"
               option-text="value"
               :isDisabled="isReadOnlyMode"
               :placeholder="$t('CONTENT.choose')"
               v-model="currentCounterpartyId"></cool-select>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		props: {
			counterpartyItem: {
				type: Object
      },
			counterpartyItemIndex: {
				type: Number
      },
      isReadOnlyMode: {
        type: Boolean
      },
    },
		computed: {
			...mapGetters(["getCounterpartiresForContract"]),
			counterparties() {
				return this.getCounterpartiresForContract;
			},
			currentCounterpartyId: {
				get() {
					if(this.counterpartyItem.counterpartyId === '' || this.counterpartyItem.counterpartyId === null) {
						return null;
          } else {
						return this.counterpartyItem.counterpartyId;
					}
				},
				set(newVal) {
          this.counterpartyItem.counterpartyId = newVal;
          this.$emit('selectCounterparty');
        }
			},
		},
	}
</script>

